import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { Dialog } from "primereact/dialog";
import { Button } from "../../../../components/ui/Button";

import { toggleDialog } from "../../../../redux/Slices/Global/globalSlice";

function DeleteMediaDialog({ usage, isLoading = false, deleteHandler, data }) {
    const { t } = useTranslation();
    const { openDialog } = useSelector((state) => state.global);
    const dispatch = useDispatch();


    const confirmDelete = () => deleteHandler();
    const onClose = () => {
        dispatch(toggleDialog("deleteMediaDialog"));
    };

    const footer = (
        <>
            <Button label={t('buttons.no')} icon="pi pi-times" className="p-button-text" disabled={isLoading} onClick={onClose} />
            <Button label={t('buttons.yes')}
                icon="pi pi-checks" className="p-button-text p-component p-confirm-dialog-accept p-button-danger"
                loading={isLoading} disabled={isLoading}
                onClick={confirmDelete}
            />
        </>
    );


    return (
        <Dialog
            visible={openDialog.deleteMediaDialog}
            onHide={onClose}
            footer={footer}
            draggable={false}
            breakpoints={{ "960px": "95vw" }}
            style={{ width: "30vw" }}
            header={t('media.media_delete_confirm_title')}
        >
            <div className='text-center'>
                <i className="mt-3 pi pi-exclamation-triangle mr-3 d-block" style={{ fontSize: '2rem' }} />
                <br />
                <span>{t('media.media_delete_confirm_text')} </span>
                {data.file_name.length > 20 ?
                    <>
                        <br /> <b>{data.file_name} </b>?
                    </> : <>
                        <b>{data.file_name} </b>?
                    </>}


                {usage ? (
                    <div className="   ">
                        {/* Usage Summary */}
                        {(usage.playlists?.length > 0 ||
                            usage.campaigns?.length > 0 ||
                            usage.layouts?.length > 0 ||
                            usage.animatedLayouts?.length > 0) ? (
                            <div className="mx-5 my-2 text-start  font-semibold text-gray-800">
                                {t('media.media_used_in')}
                            </div>
                        ) : (
                            <div className=" my-2 font-semibold text-gray-500">
                                {t('media.media_not_used')}
                            </div>
                        )}
                        <div className="mb-3  mx-5">

                            {[
                                { label: t('media.media_usage_playlists'), items: usage.playlists },
                                { label: t('media.media_usage_layouts'), items: usage.layouts },
                                { label: t('media.media_usage_campaigns'), items: usage.campaigns },
                                { label: t('media.media_usage_animated_layouts'), items: usage.animatedLayouts },
                            ].map(
                                (section, idx) =>
                                    section.items?.length > 0 && (
                                        <div key={idx} className="flex   gap-3">
                                            <div className="gap-1 flex min-w-[91px] text-start font-bold text-gray-700">
                                                <span>• </span>
                                                {section.label}:

                                            </div>
                                            <div className="  items-center  flex flex-wrap gap-1 text-gray-600">
                                                {section.items.map((item, index) => (
                                                    <span className="text-[15px]" style={{ lineHeight: "19px" }} key={index}>
                                                        {item}
                                                        {index < section.items.length - 1 ? "," : "."}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                ) : null}



            </div>
        </Dialog>
    );
}

export default DeleteMediaDialog;
